module.exports = __webpack_public_path__ + "media/application/icon-checked--white-203985c0.svg";